import { memoCandidateColumn } from './columns.js'
import type { MemoCandidateColumn } from './columns.js'
import type { MemoTemplate } from './schema.js'

/** A section as the datastore lists it. */
interface SectionOption {
  id: string
  title: string
}

/**
 * The section filter the dialog opens with, one list of section uuids per
 * candidate column, resolved from the titles the template's sources name.
 *
 * A title the datastore has no section for is skipped, so a column whose
 * titles all miss opens unfiltered rather than matching nothing.
 */
export function initialSectionFilter(
  template: MemoTemplate,
  sections: SectionOption[]
): Record<MemoCandidateColumn, string[]> {
  const filter: Record<MemoCandidateColumn, string[]> = {
    print: [],
    planning: [],
    article: [],
    events: []
  }

  for (const source of template.sources) {
    const column = filter[memoCandidateColumn(source.type)]

    for (const title of source.sections) {
      const key = title.trim().toLocaleLowerCase()
      const match = sections.find((section) => section.title.trim().toLocaleLowerCase() === key)

      if (match && !column.includes(match.id)) {
        column.push(match.id)
      }
    }
  }

  return filter
}
